import { Card } from '../product-card-gallery-composable'
import type { Props } from '../product-card-gallery'
import { WindowBreakpoints } from '@dustin-web/microsite-config'
import { getImageWidthHeight, getShowBadge } from '../utils'
import classNames from 'classnames'

export default function ProductCard({
  showFavoritesButton = true,
  primary = true,
  showActionRow = true,
  product,
  breakpoints,
  toggles,
  ...props
}: Props & { breakpoints: WindowBreakpoints }) {
  const { defaultImageWidth, defaultImageHeight, mobileWidth, mobileHeight } =
    getImageWidthHeight(breakpoints)

  const imageWidth = props.cardClasses?.length ? mobileWidth : defaultImageWidth
  const imageHeight = props.cardClasses?.length ? mobileHeight : defaultImageHeight
  const categoryName = product.categoryName || product.category?.name

  return (
    <Card.Container
      sizeClasses={props.sizeClasses}
      isExtraItem={props.isExtraItem}
      inFilterList={props.inFilterList}
      digitalDataOrigin={props.digitalDataOrigin}
      digitalIndex={props.digitalIndex}
      product={product}>
      <Card.Wrapper
        cardClasses={props.cardClasses}
        showBadge={getShowBadge(product)}
        withBorder={props.withBorder}>
        <Card.Picture
          product={product}
          ticket={props.ticket}
          imageWidth={imageWidth}
          imageHeight={imageHeight}
          imagePriority={props.imagePriority}
          digitalDataIndex={props.digitalIndex}
          digitalDataOrigin={props.digitalDataOrigin}
        />
        <Card.Content>
          <Card.Top>
            <Card.Title
              product={product}
              ticket={props.ticket}
              digitalDataIndex={props.digitalIndex}
              digitalDataOrigin={props.digitalDataOrigin}
              hTag={props.hTag}
            />
            <Card.SpecificationList slim={props.slim} list={product.promotedSpecifications} />
          </Card.Top>
          <Card.Center>
            <Card.Stars reviewCount={product.reviewCount} reviewScore={product.reviewScore} />
            <Card.Badge
              isAvailableForSale={product.availability?.isAvailableForSale}
              price={product.price}
              isNewProduct={product.isNewProduct}
            />
            <Card.Energy
              energyLabelImageId={product.energyLabelImageId}
              energyClass={product.energyClass}
              energyDocumentId={product.energyDocumentId}
              nameSlug={product.nameSlug}
              manufacturerName={product.manufacturerName}
              id={product.id}
              displayName={product.displayName}
              displaySpecifications={product.displaySpecifications}
              textAlignment={breakpoints.min.LG && !breakpoints.min.XL ? 'bottom' : 'right'}
              isMinSmallMobile={breakpoints.min.SM}
            />
            <Card.Price
              price={product.price}
              isAvailableForSale={product.availability?.isAvailableForSale}
            />
            <Card.ButtonRow>
              <Card.ToProductButton
                productErpIdentifier={product.productErpIdentifier}
                nameSlug={product.nameSlug}
                product={product}
                ticket={props.ticket}
                mainProductErpIdentifier={props.mainProductErpIdentifier}
                digitalDataOrigin={props.digitalDataOrigin}
                digitalIndex={props.digitalIndex}
                primary={primary}
                showFavoritesButtonBreakpoint={showFavoritesButton && breakpoints.min.SM}
                isMinSmallMobile={breakpoints.min.SM}
                isProductAccessories={props.isProductAccessories}
                preventSetLastUpdatedProductErpIdentifier={
                  props.preventSetLastUpdatedProductErpIdentifier
                }
              />
              <Card.Favorites
                show={showFavoritesButton && breakpoints.min.SM}
                product={product}
                digitalDataOrigin={props.digitalDataOrigin}
              />
            </Card.ButtonRow>
            <Card.ActionRow
              showActionRow={showActionRow}
              classes={classNames({ 'flex-column': toggles?.availabilityTest })}>
              <Card.Availability availability={product.availability} isBid={product.price?.isBid} />
              <Card.Compare
                categoryName={categoryName}
                id={product.id}
                displayName={product.displayName}
              />
            </Card.ActionRow>
          </Card.Center>
        </Card.Content>
      </Card.Wrapper>
    </Card.Container>
  )
}
